import React from 'react';
import { Provider } from 'react-redux';
import { Router, Route, Switch } from 'react-router-dom';
// import createStore, { history } from './store';
import configureStore, { history } from './store';
import App from './containers/App';
import throttle from 'lodash/throttle';
import { STATE, getStorageItem, setStorageItem } from 'services/Authentication';


const loadState = () => {
    try {
        const serializedState = getStorageItem(STATE);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (e) {
        return undefined;
    }
};

const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        setStorageItem(STATE, serializedState);
    } catch (e) {
        // Ignore write errors;
    }
};

const persistedState = loadState();

export const store = configureStore(persistedState);

// export const store = configureStore();

// SUBSCRIBE - Adds a change listener. It will be called any time an action is dispatched,
// and some part of the state tree may potentially have changed. 
// You may then call getState() to read the current state tree inside the callback.
// Serialization is an expensive operation. 
// Using the throttle function (by lodash) to limit the number of saves
store.subscribe(throttle(() => {
    saveState(store.getState());
}, 1000));

const MainApp = () =>
    <Provider store={store}>
        <Router history={history}>
            <Switch>
                <Route path="/" component={App} />
            </Switch>
        </Router>
    </Provider>;


export default MainApp;


// WEBPACK FOOTER //
// ./MainApp.js